import { Gender } from './Gender';

export const GenderCoefficient = {
    [Gender.Male]: 0.75,
    [Gender.Female]: 0.66,
};
